'use client'

import Script from 'next/script'

/**
 * onLoad callbacks are functions, which can't cross the Server -> Client
 * Component prop boundary. This component owns that boundary so the (server)
 * root layout only ever passes it serialisable string props.
 */
export function AnalyticsScripts({
  gaId,
  googleAdsId,
  metaPixelId,
  tiktokPixelId,
}: {
  gaId: string
  googleAdsId: string
  metaPixelId: string
  tiktokPixelId: string
}) {
  // No id means a non-production environment (see src/lib/config.ts), so
  // nothing loads at all rather than a tag pointed at an empty id.
  if (!gaId) return null
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
      />
      <Script
        src="/gtag-init.js"
        strategy="afterInteractive"
        onLoad={() => {
          if (typeof window.gtag === 'function') {
            window.gtag('config', gaId)
            if (googleAdsId) window.gtag('config', googleAdsId)
          }
        }}
      />

      {metaPixelId && (
        <>
          <Script
            src="/meta-pixel-init.js"
            strategy="afterInteractive"
            onLoad={() => {
              if (typeof (window as any).fbq === 'function') {
                ;(window as any).fbq('init', metaPixelId)
                ;(window as any).fbq('track', 'PageView')
              }
            }}
          />
          <noscript>
            {/* eslint-disable-next-line @next/next/no-img-element -- next/image needs JS, this fires inside noscript */}
            <img
              height="1"
              width="1"
              style={{ display: 'none' }}
              src={`https://www.facebook.com/tr?id=${metaPixelId}&ev=PageView&noscript=1`}
              alt=""
            />
          </noscript>
        </>
      )}

      {tiktokPixelId && (
        <Script
          src="/tiktok-pixel-init.js"
          strategy="afterInteractive"
          onLoad={() => {
            if ((window as any).ttq) {
              ;(window as any).ttq.load(tiktokPixelId)
              ;(window as any).ttq.page()
            }
          }}
        />
      )}
    </>
  )
}
